import { useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';

import { useCreateReportMutation } from '../../redux/services/reportApi';
import CustomDialog from '../common/CustomDialog';
import ReportForm from './ReportForm';

const Dialog = ({isOpen, onClose, onSubmit}) => (
  <CustomDialog
    isOpen={isOpen}
    onClose={onClose}
    title="Create New Report"
    maxWidth="sm"
  >
    <ReportForm onSubmit={onSubmit} />
  </CustomDialog>
);

const handleSubmit = ({post, onClose}) => async (e, formValues) => {
  const response = await post(formValues);
  if (response.error) return response;
  onClose();
}

const NewReportButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [post] = useCreateReportMutation();
  const onClose = e => setIsOpen(false);
  const onSubmit = handleSubmit({post, onClose});
  return (
    <>
      <Dialog
        isOpen={isOpen}
        onClose={onClose}
        onSubmit={onSubmit}
      />
      <Button
        variant='contained'
        color='success'
        size='small'
        onClick={e => setIsOpen(true)}
      >
        <AddIcon sx={{mr: 1}}/>
        New Report
      </Button>
    </>
  );
};

export default NewReportButton;